/// <reference path="../typings/index.d.ts" />
declare var chrome: any;
namespace App {
    export class AnaliseClube {
        private ajax: IAjax;
        private arrayJogadores: any = [];
        private arrayNomesJogadores: any = [];
        private static dataTableJogadores: any;
        public static tentando: boolean = false;
        public static analiseAtiva: boolean = false;
        public static valorEncontrado: boolean = false;
        public static resultadoAnterior: number = null;
        public static valorDaPesquisaAnterior: number = null;
        public static sniperTravado: number;
        public static loopAnalise: any;
        public static arrayLoopTentativas: any;
        private idExtensao: string = null;
        public static arrayPrecosJogadoresClube: any = [];
        private static keyStorageArrayAnalisePrecosJogadoresClube: string = "fsw_array_analise_precos_jogadores_clube_";

        public inicializarEventos(idExtensao: string) {
            this.idExtensao = idExtensao;
            App.AnaliseClube.arrayLoopTentativas = [];
            App.AnaliseClube.sniperTravado = 0;
            App.AnaliseClube.keyStorageArrayAnalisePrecosJogadoresClube = App.AnaliseClube.keyStorageArrayAnalisePrecosJogadoresClube + App.Sniper.dadosContaEa.id;
            if (!App.Util.empty(App.Util.getArrayStorage(App.AnaliseClube.keyStorageArrayAnalisePrecosJogadoresClube))) {
                App.AnaliseClube.arrayPrecosJogadoresClube = App.Util.getArrayStorage(App.AnaliseClube.keyStorageArrayAnalisePrecosJogadoresClube);
            }

            $("#btnAnalise").on('click', () => { this.processarPrecoFutbinDosJogadores(); });
            $("#btnPararAnalise").on('click', () => { this.pararProcesso(); });
            $(document).on('click', '.btn-desatualizado', (e) => { this.atualizarPrecoJogador(e); });
            App.Util.exibirModalPaginaCarregando();
            $.getJSON("/players.json", (data) => {
                this.arrayNomesJogadores = data;
                setTimeout(() => {
                    this.montarListaDeJogadores();
                }, 5000);
            });
        }

        private montarListaDeJogadores() {
            $.each(App.Sniper.arrayJogadoresClube, (index, value) => {
                if (value.itemType == "player") {
                    value.sellerName = this.obterNomeJogadorPorAssetId(value.assetId);
                    this.arrayJogadores.push(value);
                }

                //Terminou de carregar a Lista dos jogadores da transferencia
                if (App.Sniper.arrayJogadoresClube.length == index + 1) {
                    this.processarTabela();
                    this.processarPrecoFutbinDosJogadores();
                }
            });
        }

        private obterNomeJogadorPorAssetId(assetId: number) {
            var obj = this.arrayNomesJogadores.Players.find((x: any) => x.id === assetId);
            return obj.hasOwnProperty('c') ? obj.c : obj.f + ' ' + obj.l;
        }

        private processarTabela() {
            App.AnaliseClube.dataTableJogadores = $('#tabelaJogadores').DataTable({
                language: {
                    url: "https://cdn.datatables.net/plug-ins/1.10.19/i18n/Portuguese-Brasil.json"
                },
                data: this.arrayJogadores,
                columnDefs: [
                    {
                        targets: 0,
                        render: function(data: any, tipo: any, obj: any, meta: any) {
                            var qualidade = obj.assetId != obj.resourceId ? 'especial' : (obj.rating < 65 ? 'bronze' : (obj.rating < 75 ? 'prata' : 'ouro'));
                            var urlFutbin = "";
                            data = '<th scope="row"><div class="media align-items-center"><div><img alt="Image placeholder" src="https://cdn.futnext.com/player/' + obj.assetId + '.png" class="avatar ' + qualidade + ' rounded-circle"></div><div class="media-body ml-4"><span class="name mb-0 text-uppercase" style="color: #000000;font-weight: 700;"><a target="_blank" href="' + urlFutbin + '">' + obj.sellerName + '</a></span><div><span class="" style="display: inline-block;"><a><img style="width:20px;" src="https://cdn.futnext.com/club/' + obj.teamid + '.png"></a><a><img style="width: 24px;" src="https://cdn.futnext.com/nation/' + obj.nation + '.png"></a><a><img style="width: 24px;" src="https://futhead.cursecdn.com/static/img/19/leagues/' + obj.leagueId + '.png"></a></span></div></div></div></th>';
                            return data;
                        }
                    },
                    {
                        targets: 1,
                        className: "overal",
                        render: function(data: any, tipo: any, obj: any, meta: any) {
                            var qualidade = obj.assetId != obj.resourceId ? 'especial' : (obj.rating < 65 ? 'bronze' : (obj.rating < 75 ? 'prata' : 'ouro'));
                            data = '<span class="badge badge-pill badge-primary text-uppercase ' + qualidade + '">' + obj.rating + '</span>';
                            return data;
                        }
                    },
                    {
                        targets: 2,
                        className: "posicao",
                        render: function(data: any, tipo: any, obj: any, meta: any) {
                            data = obj.preferredPosition;
                            return data;
                        }
                    },
                    {
                        targets: 3,
                        className: "valor_compra",
                        render: function(data: any, tipo: any, obj: any, meta: any) {
                            data = obj.lastSalePrice;
                            return data;
                        }
                    },
                    {
                        targets: 4,
                        className: "valor",
                        render: function(data: any, tipo: any, obj: any, meta: any) {
                            data = obj.discardValue;
                            return data;
                        }
                    },
                    {
                        targets: 5,
                        render: function(data: any, tipo: any, obj: any, meta: any) {
                            data = '-';
                            if ($.isNumeric(obj.discardValue)) {
                                var lucro = obj.discardValue - ((5 * obj.discardValue) / 100) - obj.lastSalePrice;
                                if (lucro > 0) {
                                    data = '<span class="status bold-600 text-success">+' + Math.round(lucro) + '</span>';
                                } else if (lucro < 0) {
                                    data = '<span class="status bold-600 text-danger">' + Math.round(lucro) + '</span>';
                                } else {
                                    data = '<span class="status bold-600">' + Math.round(lucro) + '</span>';
                                }
                            }
                            return data;
                        }
                    },
                    {
                        targets: 6,
                        className: "local",
                        render: function(data: any, tipo: any, obj: any, meta: any) {
                            data = obj.hasOwnProperty('local') ? obj.local : ' - ';
                            return data;
                        }
                    },
                    {
                        targets: 7,
                        className: "text-right",
                        render: function(data: any, tipo: any, obj: any, meta: any) {
                            data = obj.hasOwnProperty('injuryType') ? '<span>' + obj.injuryType + '</span>' :'<span>Não informado</span>';
                            return data;
                            //                            switch (obj.watched) {
                            //                                case 1:
                            //                                    data = '<button type="button" class="btn btn-1 btn-outline-primary" disabled="disabled">Processando&nbsp;<i class="fa fa-spinner fa-spin"></i></button>';
                            //                                    return data;
                            //                                case 2:
                            //                                    data = '<button type="button" class="btn btn-1 btn-outline-success btn-colocar-a-venda">Colocar a venda</button>';
                            //                                    return data;
                            //                                case 3:
                            //                                    data = '<button type="button" class="btn btn-1 btn-outline-danger">Falhou&nbsp;<i class="fa fa-exclamation-triangle"></i></button>';
                            //                                    return data;
                            //                                default:
                            //                                    data = '<button type="button" class="btn btn-1 btn-outline-warning btn-desatualizado" data-index="' + meta.row + '">Desatualizado&nbsp;<i class="fa fa-clock-o"></i></button>';
                            //                                    return data;
                            //                            }
                        }
                    }
                ]
            });
        }

        private processarPrecoFutbinDosJogadores() {
            App.Util.ocultarModalPaginaCarregando();
            App.AnaliseClube.analiseAtiva = true;
            this.botaoProcessando($("#btnAnalise"), "Analisando", true);
            App.Util.exibirLoadingProcessamento($("#loadingProcessamento"), 0);
            var index = 0;
            var quantidadeTotal = App.AnaliseClube.dataTableJogadores.rows().count();
            App.AnaliseClube.loopAnalise = setInterval(() => {
                if (!App.Util.existeIndexDataTable(App.AnaliseClube.dataTableJogadores, index)) {
                    this.pararProcesso();
                    return;
                }
                var dadosJogador = App.AnaliseClube.dataTableJogadores.row(index).data();
                if (dadosJogador.untradeable) {
                    index++;
                    return;
                }

                if (App.AnaliseClube.tentando) {
                    return;
                }

                if (index == 0) {
                    App.Util.ocultarModalPaginaCarregando();
                }
                App.Util.alterarLoadingProcessamento($("#loadingProcessamento"), Math.round((index + 1) * 100 / quantidadeTotal));
                this.executarBuscaFutBin(index, quantidadeTotal, dadosJogador);
                index++;
            }, 900);

            App.AnaliseClube.arrayLoopTentativas.push(App.AnaliseClube.loopAnalise);
        }

        private executarBuscaFutBin(index: number, quantidadeTotal: number, dadosJogador: any) {
            App.AnaliseClube.tentando = true;
            dadosJogador.watched = 1;
            App.AnaliseClube.dataTableJogadores.row(index).data(dadosJogador).draw();
            var indexItemPreco = App.Util.getIndiceArrayByResourceId(App.AnaliseClube.arrayPrecosJogadoresClube, dadosJogador.resourceId);
            if (!App.Util.empty(App.AnaliseClube.arrayPrecosJogadoresClube[indexItemPreco])) {
                dadosJogador.discardValue = App.AnaliseClube.arrayPrecosJogadoresClube[indexItemPreco].preco;
                dadosJogador.injuryType = App.AnaliseClube.arrayPrecosJogadoresClube[indexItemPreco].ultimaAtualizacao;
                dadosJogador.watched = 2;
                App.AnaliseClube.tentando = false;
                App.AnaliseClube.dataTableJogadores.row(index).data(dadosJogador).draw();
            } else {
                chrome.runtime.sendMessage(this.idExtensao, { evento: "gftb", idJogador: dadosJogador.resourceId, platform: App.Sniper.dadosContaEa.ptf },
                    (resultado: any) => {
                        if (resultado.status) {
                            App.AnaliseClube.arrayPrecosJogadoresClube.push({ resourceId: dadosJogador.resourceId, preco: resultado.response.preco, ultimaAtualizacao: resultado.response.ultimaAtualizacao });
                            dadosJogador.discardValue = resultado.response.preco;
                            dadosJogador.injuryType = resultado.response.ultimaAtualizacao;
                        } else {
                            dadosJogador.discardValue = App.Util.tratarValorDeFiltro(dadosJogador.marketDataMinPrice / 2);
                        }
                        dadosJogador.watched = 2;
                        App.AnaliseClube.tentando = false;
                        App.AnaliseClube.dataTableJogadores.row(index).data(dadosJogador).draw();


                    });
            }
            if (quantidadeTotal == (index + 1)) {
                App.Util.setArrayStorage(App.AnaliseClube.keyStorageArrayAnalisePrecosJogadoresClube, App.AnaliseClube.arrayPrecosJogadoresClube);
                App.Util.ocultarLoadingProcessamento($("#loadingProcessamento"));
            }
        }

        private processarPrecoRealDosJogadores() {
            App.AnaliseClube.analiseAtiva = true;
            this.botaoProcessando($("#btnAnalise"), "Analisando", true);
            App.Util.exibirLoadingProcessamento($("#loadingProcessamento"), 0);
            var index = 0;
            var indexTotal = App.AnaliseClube.dataTableJogadores.rows().count();
            App.AnaliseClube.loopAnalise = setInterval(() => {
                if (!App.Util.existeIndexDataTable(App.AnaliseClube.dataTableJogadores, index)) {
                    this.pararProcesso();
                    return;
                }

                if (App.AnaliseClube.tentando) {
                    return;
                }

                App.Util.alterarLoadingProcessamento($("#loadingProcessamento"), Math.round((index + 1) * 100 / indexTotal));
                var dadosJogador = App.AnaliseClube.dataTableJogadores.row(index).data();
                this.executarBusca(dadosJogador.assetId, parseInt(dadosJogador.discardValue), index, dadosJogador, App.Util.tratarValorDeFiltro(dadosJogador.discardValue / 5));
                index++;
            }, 5000);

            App.AnaliseClube.arrayLoopTentativas.push(App.AnaliseClube.loopAnalise);
        }


        private executarBusca(idJogador: number, valorDaPesquisa: number, index: number, dadosJogador: any, rage: number) {
            App.AnaliseClube.tentando = true;
            dadosJogador.watched = 1;
            App.AnaliseClube.dataTableJogadores.row(index).data(dadosJogador).draw();
            valorDaPesquisa = valorDaPesquisa < dadosJogador.marketDataMinPrice ? dadosJogador.marketDataMinPrice : (valorDaPesquisa > dadosJogador.marketDataMaxPrice ? dadosJogador.marketDataMaxPrice : valorDaPesquisa);
            valorDaPesquisa = valorDaPesquisa < 200 ? 200 : (valorDaPesquisa > 15000000 ? 15000000 : valorDaPesquisa);
            var objFiltro = this.getObjetoFiltrosBuscaDePreco(idJogador, valorDaPesquisa);
            chrome.runtime.sendMessage(this.idExtensao, { evento: "busca", dados: objFiltro },
                (resultado: any) => {
                    if (resultado.status) {
                        App.Sniper.errorsSequencia = 0;
                        var ehParaAumentar = resultado.count < 2;
                        var ehParaDiminuir = resultado.count > 10;

                        var encontrouPossivelMinimo = App.AnaliseClube.resultadoAnterior && ehParaAumentar && App.AnaliseClube.resultadoAnterior > 10;//false | false
                        var encontrouPossivelMaximo = App.AnaliseClube.resultadoAnterior && ehParaDiminuir && App.AnaliseClube.resultadoAnterior < 2;//false | false

                        var encontrouMaximo = App.AnaliseClube.valorDaPesquisaAnterior && encontrouPossivelMaximo && App.Util.decrementarValorDeFiltro(valorDaPesquisa) == App.AnaliseClube.valorDaPesquisaAnterior;
                        var encontrouMinimo = App.AnaliseClube.valorDaPesquisaAnterior && encontrouPossivelMinimo && App.Util.incrementarValorDeFiltro(valorDaPesquisa) == App.AnaliseClube.valorDaPesquisaAnterior;

                        App.AnaliseClube.valorEncontrado = (resultado.count >= 2 && resultado.count <= 10)
                            || encontrouMinimo
                            || encontrouMaximo;

                        if (App.AnaliseClube.valorEncontrado) {
                            dadosJogador.discardValue = resultado.count == 0 ? resultado.response.maxb : App.Util.decrementarValorDeFiltro(resultado.response.maxb);
                            dadosJogador.discardValue = dadosJogador.discardValue < dadosJogador.marketDataMinPrice ? dadosJogador.marketDataMinPrice : dadosJogador.discardValue;
                            dadosJogador.watched = 2;
                            App.AnaliseClube.dataTableJogadores.row(index).data(dadosJogador).draw();
                            App.AnaliseClube.tentando = false;
                        } else {
                            App.AnaliseClube.resultadoAnterior = resultado.count;
                            App.AnaliseClube.valorDaPesquisaAnterior = valorDaPesquisa;
                            if (rage <= 500) {
                                rage = App.Util.obterIncrementoValorFiltro(valorDaPesquisa);
                            } else if (encontrouPossivelMinimo) {
                                rage = App.Util.tratarValorDeFiltro(rage / 2);
                            } else if (encontrouPossivelMaximo) {
                                rage = App.Util.tratarValorDeFiltro(rage / 2);
                            }
                            var valorDaPesquisaIncrementado = App.Util.tratarValorDeFiltro(valorDaPesquisa + rage);//10000 | 11000
                            var valorDaPesquisaDecrementado = App.Util.tratarValorDeFiltro(valorDaPesquisa - rage);//9000 | 10000
                            valorDaPesquisa = ehParaDiminuir ? valorDaPesquisaDecrementado : valorDaPesquisaIncrementado;
                            if (App.AnaliseClube.analiseAtiva) {
                                App.Util.sleep(10000);
                                this.executarBusca(idJogador, valorDaPesquisa, index, dadosJogador, rage);
                            } else {
                                dadosJogador.watched = null;
                                App.AnaliseClube.dataTableJogadores.row(index).data(dadosJogador).draw();
                                App.AnaliseClube.tentando = false;
                            }
                        }
                    } else {
                        App.Sniper.errorsSequencia++;
                        if (App.Sniper.errorsSequencia <= 2 && !App.Util.inArray(resultado.response.status, [401, 403, 458])) {
                            return;
                        }

                        this.processarTrava(dadosJogador, index);
                        this.pararProcesso();
                        App.Sniper.exibirMensagemSnipeTravado("Sistema travado por segurança, você precisa se autenticar");

                        /**
                         * Se for um pedido de captcha da EA
                         */
                        if (resultado.response.status == 458) {
                            var dados: any = { id: App.Util.usuario.id };
                            this.ajax.postAcaoSemResposta(App.Util.config.urlNotificacaoCaptcha, dados);
                        }

                    }
                });
        }

        private getObjetoFiltrosBuscaDePreco(idJogador: number, valor: number): IFiltro {
            var filtro: IFiltro = {
                start: 0,
                num: 21,
                type: "player",
                maskedDefId: idJogador,
                maxb: valor,
            }

            return filtro;
        }

        private botaoProcessando(btn: JQuery, texto: string, processando: boolean) {
            btn.prop("disabled", processando);
            if (processando) {
                btn.html(texto + '&nbsp;<i class="fa fa-spinner fa-spin"></i>');
            } else {
                btn.html(texto);
            }
        }

        private atualizarPrecoJogador(e: JQueryEventObject) {
            var index = $(e.currentTarget).data('index');
            var dadosJogador = App.AnaliseClube.dataTableJogadores.row(index).data();
            App.AnaliseClube.analiseAtiva = true;
            this.executarBusca(dadosJogador.assetId, parseInt(dadosJogador.discardValue), index, dadosJogador, App.Util.tratarValorDeFiltro(dadosJogador.discardValue / 5));
        }

        private processarTrava(dadosJogador: any, index: number) {
            this.pararProcesso();
            App.AnaliseClube.sniperTravado = 1;
            dadosJogador.watched = 3;
            App.AnaliseClube.dataTableJogadores.row(index).data(dadosJogador).draw();
            App.AnaliseClube.tentando = false;
        }

        private pararProcesso() {
            App.AnaliseClube.analiseAtiva = false;
            clearInterval(App.AnaliseClube.loopAnalise);
            $.each(App.AnaliseClube.arrayLoopTentativas, function(index, value) {
                window.clearInterval(value);
            });
            App.AnaliseClube.arrayLoopTentativas = [];
            this.botaoProcessando($("#btnAnalise"), '<i class="ni ni-sound-wave"></i><span class="nav-link-inner--text">Nova Análise</span>', false);
            App.Util.ocultarLoadingProcessamento($("#loadingProcessamento"));
        }
    }
}
